import React, { useState } from 'react';
import Icon from '@/components/ui/Icon';
import { Input } from '@/components/ui/Form';

const SearchBar = () => {
  const [query, setQuery] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Search submitted:', query);
    // TODO: Make API call here, hook up data
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setQuery(e.target.value);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleSubmit(e);
    }
  };

  return (
    <form
      className="tw-invisible tw-flex tw-items-center tw-relative"
      onSubmit={handleSubmit}
    >
      <div className="tw-relative tw-flex-1">
        <Icon
          className={`tw-absolute tw-left-3 tw-top-1/2 tw-transform tw--translate-y-1/2
                      tw-text-gray-400 tw-pointer-events-none`}
          height={16}
          icon="Search"
          width={16}
        />
        <Input
          aria-label="Search Standards"
          className="tw-pl-10 tw-pr-3 tw-py-2 tw-max-w-[465px] tw-w-[465px]"
          name="search-standards"
          placeholder="Search Standards..."
          value={query}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
        />
      </div>
    </form>
  );
};

export default SearchBar;
